import Vue from 'vue';

export function isLoggedin(){
  return getToken();
}
export function getToken(){
  return Vue.cookie.get('jwt-token');
}
export function setToken(token){
  Vue.cookie.set('jwt-token', token, { expires: '1D' });
}
export function getUser(){
  return Vue.cookie.get('user');
}
export function setUser(user){
  Vue.cookie.set('user', user, { expires: '1D' });
}
export function login(user){
  setUser(JSON.stringify(user));
  setToken(user.token);
}
export function logout(){
  Vue.cookie.delete('user');
  Vue.cookie.delete('jwt-token');
}


// WEBPACK FOOTER //
// ./src/services/auth.service.js